



import React from 'react';

const styles = {
  container: {
    maxWidth: '700px',
    margin: '40px auto',
    padding: '25px',
    borderRadius: '12px',
    backgroundColor: '#f4fff4',
    border: '2px solid #008000',
    boxShadow: '0 6px 15px rgba(0, 128, 0, 0.2)',
    fontFamily: 'Segoe UI, sans-serif',
    color: '#003300',
    lineHeight: 1.6
  },
  header: {
    textAlign: 'center',
    fontSize: '30px',
    fontWeight: 'bold',
    color: '#008000',
    marginBottom: '20px'
  },
  subHeader: {
    fontSize: '22px',
    color: '#006400',
    margin: '15px 0 5px'
  },
  paragraph: {
    fontSize: '16px',
    marginBottom: '15px'
  },
  list: {
    paddingLeft: '20px',
    marginBottom: '15px'
  },
  listItem: {
    marginBottom: '8px'
  }
};

const Swift = () => {
  return (
   <>
        <section
        className="page-title"
        style={{ backgroundImage: 'url(images/background/3.jpg)' }}
      >
        <div className="auto-container">
          <h1>Swift Dzire</h1>
          <div className="bread-crumb-outer"></div>
        </div>
      </section>
    <div style={styles.container}>
      <h1 style={styles.header}>Maruti Suzuki Swift Dzire</h1>
      
      <p style={styles.paragraph}>
        The Maruti Suzuki Swift Dzire is one of India's most popular compact sedans, 
        known for its stylish design, fuel efficiency, and trusted reliability. 
        It offers a great balance of comfort, performance, and affordability, making it 
        a favorite choice among Indian families and urban drivers alike.
      </p>

      <h2 style={styles.subHeader}>Key Features:</h2>
      <ul style={styles.list}>
        <li style={styles.listItem}><strong>Engine:</strong> 1.2L DualJet VVT Petrol</li>
        <li style={styles.listItem}><strong>Mileage:</strong> Up to 22.41 km/l (Manual)</li>
        <li style={styles.listItem}><strong>Transmission:</strong> 5-speed Manual / AMT</li>
        <li style={styles.listItem}><strong>Fuel Type:</strong> Petrol</li>
        <li style={styles.listItem}><strong>Seating Capacity:</strong> 5 people</li>
        <li style={styles.listItem}><strong>Boot Space:</strong> 378 litres</li>
        <li style={styles.listItem}><strong>Infotainment:</strong> 7-inch SmartPlay touchscreen with Android Auto & Apple CarPlay</li>
      </ul>

      <h2 style={styles.subHeader}>Why Choose Swift Dzire?</h2>
      <p style={styles.paragraph}>
        With its compact footprint, the Swift Dzire is easy to maneuver in city traffic, 
        while still offering generous cabin and boot space. Its fuel efficiency and low 
        maintenance costs make it an economical choice. The refined design, modern tech, and 
        Maruti’s widespread service network add to its appeal.
      </p>

   
    </div>
   </>
  );
};

export default Swift;
